import React from 'react';
import { CheckboxProps, FormControlLabel, useTheme } from '@mui/material';
import { OrderPageCheckbox } from './OrderPageCheckbox';

export const OrderPageCheckboxRow = ({ label, ...props }: CheckboxProps & { label: React.ReactNode }) => {
  const theme = useTheme();

  return (
    <FormControlLabel
      control={<OrderPageCheckbox {...props} />}
      label={label}
      sx={{
        minHeight: 44,
        marginInline: 0,
        gap: 0.5,
        '& .MuiFormControlLabel-label': { fontSize: 16, color: theme.customTheme.palette.text.primary },
      }}
    />
  );
};
